import { colorToCss } from "../../color/color"
import { isArray, isUndefinedOrNull } from "../../utils/utils"
import { IDatalayerKey, IDatalayerMapInstance, IDataLayerValue, IDatalayerViewer, IDatalayerZoneMapInstance, ZoneTextLocation } from "../types"

export class DiscreteValuesViewer implements IDatalayerViewer {

    constructor(private _layer: IDatalayerMapInstance) {
    }

    public getFeatureFillColor(feature: any) {

        var color = [255, 255, 255, 0.75];

        var zone = <{ value: any }>feature.get("data");

        if (zone) {
            return this.getValueFillColor(zone.value);
        }

        return color;

    }

    public getValueFillColor(value: any) {

        var color = [255, 255, 255, 0.75];

        if (!isUndefinedOrNull(value)) {

            if (value.Style && isArray(value.Style.Colour)) {
                color = value.Style.Colour;
                color = color.slice();
                color[3] = 1;
            }

        }

        return color;

    }

    refresh() {
        // NOP
    }


    public getZoneValue(zone: { value: any }): any {

        return zone.value;

    }

    getZoneVisibility(zone: IDatalayerZoneMapInstance): boolean {
        return true;
    }

    getKey(): IDatalayerKey {

        const type = this._layer.type
        const values = type.Values || []

        const typeKey = values.map(v => {

            var c: string = "#fff";

            if (v.Style && v.Style.Colour) {
                c = colorToCss(v.Style.Colour);
            }

            return { value: v, text: v.Name, color: c }

        });

        const layerKey = typeKey.filter(i => this._layer.zones.some(z => z.value == i.value));

        return {
            id: `type-${type.TypeId}`,
            name: type.Name,
            typeKey: typeKey,
            layerKey: layerKey,
            numeric: false,
            fixed: true
        }

    }

    getZoneText(zone: IDatalayerZoneMapInstance, location: ZoneTextLocation) {

        if (!this.shouldShowText(location)) {
            return ""
        }

        return this.getValueText(zone.value)

    }

    getValueText(value: any) {
        const discreteValue: IDataLayerValue = value
        return discreteValue ? discreteValue.Name : ""
    }

    shouldShowText(location: ZoneTextLocation) {

        let visibleLabels = this._layer.type.VisibleLabels;
        if (!visibleLabels) return true;

        let key = ZoneTextLocation[location];
        let visible = visibleLabels[key];

        return isUndefinedOrNull(visible) ? true : !!visible;

    }

    getPointFillColor(feature: any): any {
        return this.getFeatureFillColor(feature);
    }

    getClusterPointFillColor(values: any[]): any {
        return [255, 255, 255, 0.75];
    }

}
